<template>
	<section>
        <v-progress-circular
        v-if="loading"
        id="loading_spinner"
        indeterminate
        size=64
        color="primary"
        >
        </v-progress-circular>
	</section>
</template>

<script>
export default {
  props: ['user', 'api_prefix', 'subscription_plan'],
  data: function () {
  return {
    loading: true
    }
  },
  created: function()
  {
    var redirect_path = sessionStorage.getItem('redirect_to_path');
    sessionStorage.removeItem('redirect_to_path');
    var default_path = '/subscription';
    if (localStorage.getItem('installation_completed')!='true')
    {
        default_path = '/install';
    }
	  this.$router.replace(redirect_path || default_path);
  },
	mounted: function() 
	{
		window.analytics.page('Home');
	},
	methods: 
	{

	}
}
</script>

<style scoped>

</style>